<template>
  <a-card v-if="pageLoading">
    <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="pageLoading"
    />
  </a-card>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'" v-else>
    <a-row :gutter="8">
      <a-col :xs="{ span: 24 }">
        <a-card :loading="pageLoading" class="margin-bottom">
          <div slot="title">Approval Financing</div>

          <div class="m-card-body">
            <ul class="m-list-wrapper bordered">
              <li>
                <span class="m-list-title" for>No Financing</span>
                <span class="m-list-desc">{{
                  data.header.no_trans_financing
                }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Date Financing</span>
                <span class="m-list-desc">{{
                  moment(data.header.financing_dt).format(
                    this.getStandartFormatDate
                  )
                }}</span>
              </li>
              <li>
                <span class="m-list-title" for>User Creator</span>
                <span class="m-list-desc">{{ data.header.user_pembuat }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Type - No Financing</span>
                <span class="m-list-desc"
                  >{{ data.header.type_financing }} -
                  {{ data.header.no_trans_financing }}</span
                >
              </li>
              <li>
                <span class="m-list-title" for>Nama Peminjam</span>
                <span class="m-list-desc">{{ data.header.peminjam }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Bentuk Kredit</span>
                <span class="m-list-desc">{{ data.header.bentuk_kredit }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Jenis Pinjaman</span>
                <span class="m-list-desc">{{
                  data.header.jenis_pinjaman
                }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Keperluan</span>
                <span class="m-list-desc">{{ data.header.keperluan }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Suku Bunga</span>
                <span class="m-list-desc">{{ data.header.suku_bunga }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Denda / Pinalty</span>
                <span class="m-list-desc">{{ data.header.denda_penalty }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Agunan</span>
                <span class="m-list-desc">{{ data.header.angunan }}</span>
              </li>
            </ul>
          </div>
        </a-card>
        <a-collapse class="margin-top margin-bottom" activeKey="1">
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Financing Detail</h4>
            </div>
            <ul class="m-list-wrapper bordered">
              <li>
                <span class="m-list-title" for>Jangka Waktu</span>
                <span class="m-list-desc">
                  {{
                    data.header2.jkw_start_dt
                      ? moment(
                          data.header2.jkw_start_dt,
                          getStandartFormatDate
                        ).format(getDefaultDateFormat)
                      : "-"
                  }}
                  s/d
                  {{
                    data.header2.jkw_end_dt
                      ? moment(
                          data.header2.jkw_end_dt,
                          getStandartFormatDate
                        ).format(getDefaultDateFormat)
                      : "-"
                  }}
                </span>
              </li>
              <li>
                <span class="m-list-title" for>Provisi</span>
                <span class="m-list-desc">
                  {{
                    formatCurrency(
                      "IDR",
                      data.header2.provisi ? data.header2.provisi : 0
                    )
                  }}
                </span>
              </li>
              <li>
                <span class="m-list-title" for>By. Administrasi</span>
                <span class="m-list-desc">
                  {{ formatCurrency("IDR", data.header2.biaya_admin) }}
                </span>
              </li>
              <li>
                <span class="m-list-title" for>Jumlah Fasilitas</span>
                <span class="m-list-desc">
                  {{ formatCurrency("IDR", data.header2.jml_fasilitas) }}
                </span>
              </li>
              <li>
                <span class="m-list-title" for>Used</span>
                <span class="m-list-desc">
                  {{ formatCurrency("IDR", data.header2.pemakaian) }}
                </span>
              </li>
              <li v-if="data.type == 'FK'">
                <span class="m-list-title" for>Balance</span>
                <span class="m-list-desc">
                  {{ formatCurrency("IDR", data.header2.balance) }}
                </span>
              </li>
            </ul>
          </a-collapse-panel>
        </a-collapse>

        <a-collapse class="margin-top margin-bottom" activeKey="1">
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove" v-if="data.type == 'FK'">
                Pemakaian Hutang
              </h4>
              <h4 class="margin-remove" v-else>Pembayaran Hutang</h4>
            </div>
            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <div v-if="data.type == 'FK'">
                  <li v-for="(list, index) in data.pemakaian" :key="index">
                    <div class="m-display-flex space-between">
                      <div class="margin-remove">
                        <span class="m-list-title" for>{{
                          list.no_contract
                        }}</span>
                        <span class="m-list-desc">
                          {{ list.no_financing_dtl }}<br />
                          {{ list.create_dt }}<br />
                          {{ formatCurrency("IDR", list.value) }}
                        </span>
                      </div>
                      <div class="margin-remove m-list-bold">
                        <div class="m-list-desc">
                          Remaining {{ formatCurrency("IDR", list.remaining) }}
                        </div>
                      </div>
                    </div>
                  </li>
                </div>
                <div v-else>
                  <li v-for="(list, index) in data.pembayaran" :key="index">
                    <div class="m-display-flex space-between">
                      <div class="margin-remove m-list-title">
                        <span class="m-list-title" for>{{
                          list.no_payment_schedule
                        }}</span>
                        <span class="m-list-desc">
                          {{ list.create_dt }}<br />
                          {{ formatCurrency("IDR", list.pokok) }}<br />
                          {{ list.no_bkm }}
                        </span>
                      </div>
                    </div>
                  </li>
                </div>
              </ul>
            </div>
          </a-collapse-panel>
        </a-collapse>

        <a-collapse class="margin-top" activeKey>
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Status</h4>
              <div>
                <Status :status="data.last_status" />
              </div>
            </div>
            <a-timeline class="m-timeline">
              <a-timeline-item color="green">
                <div class="m-timeline-title">
                  Pembuat - {{ data.user_pembuat.tlc }}
                </div>
                <div class="m-timeline-body">
                  <h4 class="margin-remove">{{ data.user_pembuat.tanggal }}</h4>
                </div>
                <div class="m-timeline-footer">
                  <a-tag color="green">{{ data.user_pembuat.status }}</a-tag>
                </div>
              </a-timeline-item>
              <a-timeline-item
                v-for="workflow in data.status"
                :key="workflow.step_no"
                :color="
                  workflow.status === 'On Process' ||
                  workflow.status === 'Delivered'
                    ? 'red'
                    : workflow.status === 'Waiting'
                    ? 'grey'
                    : 'green'
                "
              >
                <div class="m-timeline-title">
                  {{
                    workflow.actor === null ? workflow.jenis : workflow.actor
                  }}
                  {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                </div>
                <div class="m-timeline-body">
                  <h4
                    class="margin-remove"
                    v-if="workflow.tanggal_aksi !== null"
                  >
                    {{ workflow.tanggal_aksi }}
                  </h4>
                  <span
                    class="m-text-small"
                    v-if="workflow.remark == null || workflow.remark == ''"
                    >Tidak Ada Catatan</span
                  >
                  <span class="m-text-small" v-else>{{ workflow.remark }}</span>
                </div>
                <div class="m-timeline-footer">
                  <Status :status="workflow.status" />
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-collapse-panel>
        </a-collapse>
        <a-card
          class="margin-top"
          :loading="pageLoading"
          v-if="data.jenis.toLowerCase() === 'approve'"
        >
          <div slot="title">Manifest Actions</div>

          <a-form :form="form">
            <a-form-item label="Note">
              <a-textarea
                placeholder="Write the note here ... "
                :rows="2"
                v-decorator="['catatan']"
              />
            </a-form-item>
            <a-form-item label="Actions">
              <a-select
                showSearch
                v-decorator="['aksi', { rules: [{ required: true }] }]"
              >
                <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                  item.aksi
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Password">
              <a-input
                type="password"
                placeholder="Password"
                v-decorator="['password', { rules: [{ required: true }] }]"
              />
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-button
                @click="handleSubmit"
                block
                type="primary"
                html-type="submit"
                >Save</a-button
              >
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import Status from "@/components/Status.vue";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";

export default {
  name: "manifestapproval",
  props: ["id"],
  components: { Status },
  mixins: [CurrencyFormat],
  data() {
    return {
      pageLoading: true,
      data: {},
      submit: {},
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetchManifest();
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
      }
    },
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
    ]),
  },
  methods: {
    moment,
    fetchManifest() {
      axios({
        method: "get",
        url: this.$serviceUrl + "public_manifest/manifest_financing",
        params: {
          id: this.id,
        },
      })
        .then((response) => {
          this.data = {
            type: response.data.header1[0].type_financing,
            header: response.data.header1[0],
            header2: response.data.header2[0],
            pemakaian: response.data.detil,
            pembayaran: response.data.payment,
            actor: response.data.tlc,
            id: response.data.id_manifest,
            jenis: response.data.jenis,
            last_status: response.data.last_status,
            user_pembuat: {
              tlc: response.data.header1[0].user_pembuat,
              tanggal: response.data.header1[0].financing_dt,
              status: "Created",
            },
            status: response.data.status_app,
            aksi: response.data.aksi,
          };
          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
        });
    },
    handlePrint() {},
    handleAction() {},
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.pageLoading = false;
          this.displayMessage("choose-action");
          return;
        }

        let postData = new FormData();

        postData.append("id_manifest", this.data.id);
        postData.append("status", values.aksi);
        postData.append(
          "remark",
          values.catatan !== undefined ? values.catatan : ""
        );
        postData.append("tlc", this.data.actor);
        postData.append("password", values.password);

        axios({
          method: "post",
          url: this.$serviceUrl + "public_manifest/approval_financing",
          processData: false,
          data: postData,
        })
          .then((response) => {
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            // console.log("error : " + err);
            if (err.response.data.status === false) {
              this.displayMessage("wrong-password");
            }
            this.pageLoading = false;
          });
      });
    },
  },
};
</script>

<style>
</style> 